import * as React from 'react';
// tslint:disable-next-line:no-var-requires
const apple = require('../../resources/apple.png');
// tslint:disable-next-line:no-var-requires
const ductDesign = require('../../resources/duct-design.png');
// tslint:disable-next-line:no-var-requires
const invoices = require('../../resources/invoices.png');
// tslint:disable-next-line:no-var-requires
const news = require('../../resources/news.png');
// tslint:disable-next-line:no-var-requires
const orders = require('../../resources/orders.png');
// tslint:disable-next-line:no-var-requires
const shipments = require('../../resources/shipments.png');
// tslint:disable-next-line:no-var-requires
const shoppingCart = require('../../resources/shopping-cart.png');
// tslint:disable-next-line:no-var-requires
const USD = require('../../resources/USD.png');
// tslint:disable-next-line:no-var-requires
const QFV = require('../../resources/3d.png');

const tileArr = [
    {
        tileLogo: <img src={shoppingCart} />,
        tileHead: 'Quick Tick Online',
        tileBody: [
            { linkName: 'Quote or order Nordfab products', url: 'https://www.quicktickonline.com/quicktick/qtportal/' }
        ]
    },
    {
        tileLogo: <img src={USD} />,
        tileHead: 'Recent Opportunities',
        tileBody: [
            { linkName: 'John Smith, X Corp, Baltimore' },
            { linkName: 'Lead2' },
            { linkName: 'Lead3' },
            { linkName: 'See all leads' }
        ]
    },
    {
        tileLogo: <img src={ductDesign} />,
        tileHead: 'Duct Installation Design',
        tileBody: [
            {
                linkName: 'Request a new Nordfab Drawing Service',
                url: 'http://www.nordfab.com/request-nordfab-engineering-drawing-service/'
            },
            { linkName: 'See drawings requests' },
            {
                linkName: 'Download NordCad 3.1Q',
                url: 'http://www.nordfab.com/register-download-nordcad-3-1q-nordfab-authorized-dealer/'
            },
            {
                linkName: 'Download 3D Warehouse for SketchUp',
                url:
                    'http://www.nordfab.com/nordfabs-3d-warehouse-for-trimble-sketchup/' +
                    'register-to-download-user-information-for-nordfab-3d-warehouse/'
            }
        ]
    },
    {
        tileLogo: <img src={orders} />,
        tileHead: 'Submitted Orders',
        tileBody: [
            { linkName: 'Order 1' },
            { linkName: 'Order 2' },
            { linkName: 'Order 3' },
            { linkName: 'See more submitted orders' }
        ]
    },
    {
        tileLogo: <img src={invoices} />,
        tileHead: 'Invoices',
        tileBody: [
            { linkName: 'Invoice 1' },
            { linkName: 'Invoice 2' },
            { linkName: 'Invoice 3' },
            { linkName: 'ISee more Invoices...' }
        ]
    },
    {
        tileLogo: <img src={news} />,
        tileHead: 'Recent News',
        tileBody: [
            { linkName: 'New product' },
            { linkName: 'Nordfab at LA PAX to design cooling solutions' },
            { linkName: 'Nordfab to recive design price' }
        ]
    },
    {
        tileLogo: <img src={apple} />,
        tileHead: 'Resources & Training',
        tileBody: [
            {
                linkName: 'Quick-Fit Visual® (QFV) introductory & tutorial videos',
                url: 'https://www.nordfab.com/en-us/technical/quick-fit-visual-video-na'
            },
            {
                linkTitle: 'NFU: ',
                links: [
                    {
                        linkName: 'Register for training at NFU',
                        url: 'https://www.nordfab.com/Technical/Nordfab-University'
                    },
                    {
                        linkName: 'Why attend?',
                        url: 'https://www.nordfab.com/en-us/technical/nordfab-university'
                    }
                ]
            },
            {
                linkTitle: 'Product: ',
                links: [
                    {
                        linkName: 'Nordfab Product Reference',
                        url: 'https://www.nordfab.com/en-us/Literature/qf-and-flanged-ducting-product-reference'
                    },
                    {
                        linkName: 'Price List',
                        url: 'https://www.nordfab.com/en-us/literature/catalogues/nordfab-price-list'
                    }
                ]
            },
            {
                linkName: 'How to order ducting from Nordfab',
                url: 'https://www.nordfab.com/Technical/Notes-for-ordering-quick-fit'
            },
            {
                linkName: 'Drawing Service Order Form',
                url:
                    'https://www.nordfab.com/en-us/Technical/Nordfab Installation Design Tools/request-nordfab-engineering-drawing-service'
            },
            {
                linkName: 'Transitions Specification Form',
                url: 'https://www.nordfab.com/en-us/technical/nordfab-duct-hoods-and-transitions'
            },
            {
                linkName: 'Manifolds Specification Form',
                url: 'https://www.nordfab.com/en-us/literature/catalogues/manifold-specification-form'
            },
            {
                linkTitle: 'Custom Flanges Order Forms: ',
                links: [
                    {
                        linkName: 'Rectangular',
                        url: 'https://www.nordfab.com/en-us/literature/catalogues/custom-flange-form-rect'
                    },
                    {
                        linkName: 'Circular',
                        url: 'https://www.nordfab.com/en-us/literature/catalogues/custom-flange-form-circle'
                    }
                ]
            }
        ]
    },
    {
        tileLogo: <img src={shipments} />,
        tileHead: 'Shipments',
        tileBody: [
            { linkName: 'Order 1' },
            { linkName: 'Order 2' },
            { linkName: 'Order 3' },
            { linkName: 'See more shipmenets' }
        ]
    }, 
    {
        tileLogo: <img src={QFV} />,
        tileHead: 'QUICK-FIT VISUAL DUCT DESIGN (QFV)',
        tileBody: [
            { linkName: 'Design a ducting installation', url: 'https://qfv.netprm.com/' }
        ]
    },     
];

export default tileArr;



// WEBPACK FOOTER //
// ./src/containers/home/hardCodedData.tsx